import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { ReactNode, useEffect, useState, JSX } from 'react';
import { Collapse } from 'reactstrap';

export interface Props {
  title: string;
  children: ReactNode;
  isOpen?: boolean;
  className?: string;
}
const CollapseWrapper = (props: Props): JSX.Element => {
  const { children, title, isOpen, className } = props;

  const [isCollapsed, setIsCollapsed] = useState(!isOpen);

  const toggle = (): void => setIsCollapsed(!isCollapsed);

  useEffect(() => {
    if (!isOpen) {
      setIsCollapsed(true);
    }
  }, [isOpen]);

  return (
    <div className={className}>
      <button
        className="collapseHeader m-0 bg-transparent p-0 w-100 align-items-baseline"
        onClick={toggle}
      >
        <p className={'collapseHeader__text'}>{title}</p>
        <span className="collapseHeader__icon">
          {isCollapsed && <FontAwesomeIcon icon={faChevronDown} />}
          {!isCollapsed && <FontAwesomeIcon icon={faChevronUp} />}
        </span>
      </button>
      <Collapse isOpen={!isCollapsed}>{children}</Collapse>
    </div>
  );
};
export default CollapseWrapper;
